exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".dps-input-group{display:flex;justify-content:space-between}.dps-input{padding:4px;border-radius:2px;border:1px solid #e6e6e6;outline:none;height:15px;width:45%;font-size:12px}.dps-box{position:relative;background:#feffeb;border:1px solid #d9dabd;padding:10px;width:80%;margin:10px}.dps-box:after,.dps-box:before{bottom:100%;left:10%;border:solid transparent;content:\" \";height:0;width:0;position:absolute;pointer-events:none}.dps-box:after{border-color:rgba(136,183,213,0);border-bottom-color:#feffeb;border-width:5px;margin-left:-5px}.dps-box:before{border-color:rgba(194,225,245,0);border-bottom-color:#d9dabd;border-width:6px;margin-left:-6px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ac57058e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/MediumItem.vue
// module id = 31
// module chunks = 0